function scrollBySlide(el: HTMLElement, dir: 1 | -1 = 1) {
  const slideWidth = el.firstElementChild?.getBoundingClientRect().width ?? 0;
  if (!slideWidth) return;

  const maxLeft = el.scrollWidth - el.clientWidth;

  // Fractional pixels happen a lot on mobile (zoom / DPR / transforms)
  const EPS = 2;

  const atStart = el.scrollLeft <= EPS;
  const atEnd = el.scrollLeft >= maxLeft - EPS;

  if ((dir === -1 && atStart) || (dir === 1 && atEnd)) return;

  // Clamp target into [0, maxLeft]
  const target = Math.min(
    maxLeft,
    Math.max(0, el.scrollLeft + slideWidth * dir),
  );

  // If clamping means "no movement", don't call scrollTo (prevents the "trying" feeling)
  if (Math.abs(target - el.scrollLeft) <= EPS) return;

  el.scrollTo({ left: target, behavior: "smooth" });
}

export { scrollBySlide };
